import { GetterTree } from 'vuex'
import { AdvertiseDashboardState } from './state'

export default {
  balance(state) {
    return state.balance
  }
} as GetterTree<AdvertiseDashboardState, any>
